import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { OrganizationRiderServiceLevel, OrganizationServiceLevel } from '@uzurv/clara';
import { isNullOrUndefined } from '@uzurv/core';

@Component({
  selector: 'uz-organization-rider-service-levels',
  templateUrl: './organization-rider-service-levels.component.html',
  styleUrls: ['./organization-rider-service-levels.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrganizationRiderServiceLevelsComponent implements OnChanges {
  @Input() organizationServiceLevels: Array<OrganizationServiceLevel>;

  @Input() organizationRiderServiceLevels = new Array<OrganizationRiderServiceLevel>();

  @Input() placeholderMessage: string;

  @Output() organizationServiceLevelChange: EventEmitter<OrganizationRiderServiceLevel> = new EventEmitter<OrganizationRiderServiceLevel>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['organizationServiceLevels'] && !isNullOrUndefined(changes['organizationServiceLevels'].currentValue)) ||
      (changes['organizationRiderServiceLevels'] && !isNullOrUndefined(this.organizationServiceLevels))
    ) {
      this.organizationRiderServiceLevels = this.organizationServiceLevels.map(organizationServiceLevel => {
        const existingOrganizationRiderServiceLevel = this.organizationRiderServiceLevels.find(
          orsl => orsl.serviceLevel.code === organizationServiceLevel.serviceLevel.code
        );
        if (isNullOrUndefined(existingOrganizationRiderServiceLevel)) {
          const organizationRiderServiceLevel = new OrganizationRiderServiceLevel();
          organizationRiderServiceLevel.serviceLevel = organizationServiceLevel.serviceLevel;
          // null represents the service level preference has not been captured for this service level
          organizationRiderServiceLevel.enabled = organizationServiceLevel.optional ? null : true;
          return organizationRiderServiceLevel;
        } else {
          return existingOrganizationRiderServiceLevel;
        }
      });
    }
  }

  handleOptionalOrganizationRiderServiceLevelChange(organizationRiderServiceLevel: OrganizationRiderServiceLevel, enabled: boolean) {
    organizationRiderServiceLevel.enabled = enabled;
    this.organizationServiceLevelChange.emit(organizationRiderServiceLevel);
  }

  get optionalOrganizationRiderServiceLevels(): Array<OrganizationRiderServiceLevel> {
    if (!isNullOrUndefined(this.organizationRiderServiceLevels)) {
      return this.organizationRiderServiceLevels.filter(
        orsl => this.organizationServiceLevels.find(osl => osl.serviceLevel.code === orsl.serviceLevel.code).optional
      );
    }
  }
}
